import script from "./GmxFileUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxFileUpload.vue?vue&type=script&setup=true&lang=js"

import "./GmxFileUpload.vue?vue&type=style&index=0&id=1c851ba9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c851ba9"]])

export default __exports__